"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _d3Scale = require("d3-scale");

var _frame_props = require("./constants/frame_props");

var _orframeRules = require("./annotationRules/orframeRules");

var _baseRules = require("./annotationRules/baseRules");

var _multiAccessorUtils = require("./data/multiAccessorUtils");

var _Frame = _interopRequireDefault(require("./Frame"));

var _dataFunctions = require("./data/dataFunctions");

var _ordinal = require("./processing/ordinal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var xScale = (0, _d3Scale.scaleLinear)();
var yScale = (0, _d3Scale.scaleLinear)();
var projectedCoordinatesObject = {
  y: "y",
  x: "x"
};
var defaultOverflow = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
};

var OrdinalFrame =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OrdinalFrame, _React$Component);

  function OrdinalFrame(props) {
    var _this;

    _classCallCheck(this, OrdinalFrame);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrdinalFrame).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "defaultORSVGRule", function (_ref) {
      var d = _ref.d,
          i = _ref.i,
          annotationLayer = _ref.annotationLayer;
      var _this$props = _this.props,
          projection = _this$props.projection,
          svgAnnotationRules = _this$props.svgAnnotationRules;
      var _this$state = _this.state,
          adjustedPosition = _this$state.adjustedPosition,
          adjustedSize = _this$state.adjustedSize,
          oAccessor = _this$state.oAccessor,
          rAccessor = _this$state.rAccessor,
          oScale = _this$state.oScale,
          rScale = _this$state.rScale,
          projectedColumns = _this$state.projectedColumns,
          orFrameRender = _this$state.orFrameRender,
          pieceIDAccessor = _this$state.pieceIDAccessor,
          rScaleType = _this$state.rScaleType;
      var screenCoordinates = [0, 0]; //TODO: Support radial??

      if (d.coordinates || d.type === "enclose" && d.neighbors) {
        screenCoordinates = (d.coordinates || d.neighbors).map(function (p) {
          var pO = (0, _multiAccessorUtils.findFirstAccessorValue)(oAccessor, p) || p.column;
          var oColumn = projectedColumns[pO];
          var idPiece = (0, _orframeRules.findIDPiece)(pieceIDAccessor, oColumn, p);
          return (0, _orframeRules.screenProject)({
            p: p,
            adjustedSize: adjustedSize,
            rScale: rScale,
            rAccessor: rAccessor,
            idPiece: idPiece,
            projection: projection,
            oColumn: oColumn,
            rScaleType: rScaleType
          });
        });
      } else {
        var pO = (0, _multiAccessorUtils.findFirstAccessorValue)(oAccessor, d) || d.column;
        var oColumn = projectedColumns[pO];
        var idPiece = (0, _orframeRules.findIDPiece)(pieceIDAccessor, oColumn, d);
        screenCoordinates = (0, _orframeRules.screenProject)({
          p: d,
          adjustedSize: adjustedSize,
          rScale: rScale,
          rAccessor: rAccessor,
          idPiece: idPiece,
          projection: projection,
          oColumn: oColumn,
          rScaleType: rScaleType
        });
      }

      var voronoiHover = annotationLayer.voronoiHover; //TODO: Process your rules first

      var customAnnotation = svgAnnotationRules && svgAnnotationRules({
        d: d,
        i: i,
        oScale: oScale,
        rScale: rScale,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        orFrameProps: _this.props,
        orFrameState: _this.state,
        screenCoordinates: screenCoordinates,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        annotationLayer: annotationLayer,
        categories: projectedColumns,
        voronoiHover: voronoiHover
      });

      if (svgAnnotationRules && customAnnotation !== null) {
        return customAnnotation;
      } else if (d.type === "desaturation-layer") {
        return (0, _baseRules.desaturationLayer)({
          style: d.style instanceof Function ? d.style(d, i) : d.style,
          size: adjustedSize,
          i: i,
          key: d.key
        });
      } else if (d.type === "ordinal-line") {
        return (0, _orframeRules.svgOrdinalLine)({
          d: d,
          screenCoordinates: screenCoordinates,
          voronoiHover: voronoiHover
        });
      } else if (d.type === "or") {
        return (0, _orframeRules.svgORRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          projection: projection
        });
      } else if (d.type === "highlight") {
        return (0, _orframeRules.svgHighlightRule)({
          d: d,
          pieceIDAccessor: pieceIDAccessor,
          orFrameRender: orFrameRender,
          oAccessor: oAccessor
        });
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _orframeRules.basicReactAnnotationRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates
        });
      } else if (d.type === "enclose") {
        return (0, _orframeRules.svgEncloseRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates
        });
      } else if (d.type === "enclose-rect") {
        return (0, _orframeRules.svgRectEncloseRule)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i
        });
      } else if (d.type === "r") {
        return (0, _orframeRules.svgRRule)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates,
          rScale: rScale,
          rAccessor: rAccessor,
          projection: projection,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition
        });
      } else if (d.type === "category") {
        return (0, _orframeRules.svgCategoryRule)({
          projection: projection,
          d: d,
          i: i,
          categories: _this.state.projectedColumns,
          adjustedSize: adjustedSize
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "defaultORHTMLRule", function (_ref2) {
      var d = _ref2.d,
          i = _ref2.i,
          annotationLayer = _ref2.annotationLayer;
      var _this$state2 = _this.state,
          adjustedPosition = _this$state2.adjustedPosition,
          adjustedSize = _this$state2.adjustedSize,
          oAccessor = _this$state2.oAccessor,
          rAccessor = _this$state2.rAccessor,
          oScale = _this$state2.oScale,
          rScale = _this$state2.rScale,
          projectedColumns = _this$state2.projectedColumns,
          summaryType = _this$state2.summaryType,
          type = _this$state2.type,
          pieceIDAccessor = _this$state2.pieceIDAccessor,
          rScaleType = _this$state2.rScaleType;
      var _this$props2 = _this.props,
          htmlAnnotationRules = _this$props2.htmlAnnotationRules,
          tooltipContent = _this$props2.tooltipContent,
          optimizeCustomTooltipPosition = _this$props2.optimizeCustomTooltipPosition,
          projection = _this$props2.projection,
          size = _this$props2.size,
          useSpans = _this$props2.useSpans;
      var screenCoordinates = [0, 0];
      var voronoiHover = annotationLayer.voronoiHover;

      if (d.coordinates || d.type === "enclose" && d.neighbors) {
        screenCoordinates = (d.coordinates || d.neighbors).map(function (p) {
          var pO = (0, _multiAccessorUtils.findFirstAccessorValue)(oAccessor, p) || p.column;
          var oColumn = projectedColumns[pO];
          var idPiece = (0, _orframeRules.findIDPiece)(pieceIDAccessor, oColumn, p);
          return (0, _orframeRules.screenProject)({
            p: p,
            adjustedSize: adjustedSize,
            rScale: rScale,
            rAccessor: rAccessor,
            idPiece: idPiece,
            projection: projection,
            oColumn: oColumn,
            rScaleType: rScaleType
          });
        });
      } else if (d.type === "column-hover") {
        var _getColumnScreenCoord = (0, _orframeRules.getColumnScreenCoordinates)({
          d: d,
          projectedColumns: projectedColumns,
          oAccessor: oAccessor,
          summaryType: summaryType,
          type: type,
          projection: projection,
          adjustedPosition: adjustedPosition,
          adjustedSize: adjustedSize
        }),
            _getColumnScreenCoord2 = _slicedToArray(_getColumnScreenCoord.coordinates, 2),
            xPosition = _getColumnScreenCoord2[0],
            yPosition = _getColumnScreenCoord2[1];

        screenCoordinates = [xPosition, yPosition];
      } else {
        var pO = (0, _multiAccessorUtils.findFirstAccessorValue)(oAccessor, d) || d.column;
        var oColumn = projectedColumns[pO];
        var idPiece = (0, _orframeRules.findIDPiece)(pieceIDAccessor, oColumn, d);
        screenCoordinates = (0, _orframeRules.screenProject)({
          p: d,
          adjustedSize: adjustedSize,
          rScale: rScale,
          rAccessor: rAccessor,
          idPiece: idPiece,
          projection: projection,
          oColumn: oColumn,
          rScaleType: rScaleType
        });
      }

      var flippedRScale = projection === "vertical" ? rScaleType.domain(rScale.domain()).range(rScale.range().reverse()) : rScale; //TODO: Process your rules first

      var customAnnotation = htmlAnnotationRules && htmlAnnotationRules({
        d: d,
        i: i,
        oScale: oScale,
        rScale: flippedRScale,
        oAccessor: oAccessor,
        rAccessor: rAccessor,
        orFrameProps: _this.props,
        screenCoordinates: screenCoordinates,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        annotationLayer: annotationLayer,
        orFrameState: _this.state,
        categories: _this.state.projectedColumns,
        voronoiHover: voronoiHover
      });

      if (htmlAnnotationRules && customAnnotation !== null) {
        return customAnnotation;
      }

      if (d.type === "frame-hover") {
        return (0, _orframeRules.htmlFrameHoverRule)({
          d: d,
          i: i,
          rAccessor: rAccessor,
          oAccessor: oAccessor,
          projection: projection,
          tooltipContent: tooltipContent,
          optimizeCustomTooltipPosition: optimizeCustomTooltipPosition,
          projectedColumns: projectedColumns,
          useSpans: useSpans,
          pieceIDAccessor: pieceIDAccessor,
          adjustedSize: adjustedSize,
          rScale: rScale,
          type: type,
          rScaleType: rScaleType
        });
      } else if (d.type === "column-hover") {
        return (0, _orframeRules.htmlColumnHoverRule)({
          d: d,
          i: i,
          summaryType: summaryType,
          oAccessor: oAccessor,
          projectedColumns: projectedColumns,
          type: type,
          adjustedPosition: adjustedPosition,
          adjustedSize: adjustedSize,
          projection: projection,
          tooltipContent: tooltipContent,
          optimizeCustomTooltipPosition: optimizeCustomTooltipPosition,
          useSpans: useSpans
        });
      }

      return null;
    });

    var baseState = {
      adjustedPosition: [],
      adjustedSize: [],
      backgroundGraphics: undefined,
      foregroundGraphics: undefined,
      axisData: undefined,
      renderNumber: 0,
      oLabels: {
        labels: []
      },
      oAccessor: (0, _dataFunctions.stringToArrayFn)("renderKey"),
      rAccessor: (0, _dataFunctions.stringToArrayFn)("value"),
      oScale: (0, _d3Scale.scaleBand)(),
      rScale: (0, _d3Scale.scaleLinear)(),
      axes: undefined,
      calculatedOExtent: [],
      calculatedRExtent: [0, 1],
      columnOverlays: [],
      dataVersion: undefined,
      legendSettings: undefined,
      margin: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      oExtent: [],
      oScaleType: (0, _d3Scale.scaleBand)(),
      orFrameRender: {},
      pieceDataXY: [],
      pieceIDAccessor: (0, _dataFunctions.stringToFn)("semioticPieceID"),
      projectedColumns: {},
      rExtent: [],
      rScaleType: (0, _d3Scale.scaleLinear)(),
      summaryType: {
        type: "none"
      },
      title: {},
      type: {
        type: "none"
      },
      props: props
    };
    _this.state = _objectSpread({}, baseState, (0, _ordinal.calculateOrdinalFrame)(props, baseState));
    Object.keys(props).forEach(function (d) {
      if (!_frame_props.ordinalframeproptypes[d]) {
        if (_frame_props.xyframeproptypes[d]) {
          console.error("".concat(d, " is an XYFrame prop are you sure you're using the right frame?"));
        } else if (_frame_props.networkframeproptypes[d]) {
          console.error("".concat(d, " is a NetworkFrame prop are you sure you're using the right frame?"));
        } else {
          console.error("".concat(d, " is not a valid OrdinalFrame prop"));
        }
      }
    });
    return _this;
  }

  _createClass(OrdinalFrame, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;

      if (onUnmount) {
        onUnmount(this.props, this.state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          annotationSettings = _this$props3.annotationSettings,
          annotations = _this$props3.annotations,
          matte = _this$props3.matte,
          renderKey = _this$props3.renderKey,
          interaction = _this$props3.interaction,
          customClickBehavior = _this$props3.customClickBehavior,
          customHoverBehavior = _this$props3.customHoverBehavior,
          customDoubleClickBehavior = _this$props3.customDoubleClickBehavior,
          projection = _this$props3.projection,
          backgroundGraphics = _this$props3.backgroundGraphics,
          foregroundGraphics = _this$props3.foregroundGraphics,
          afterElements = _this$props3.afterElements,
          beforeElements = _this$props3.beforeElements,
          disableContext = _this$props3.disableContext,
          summaryType = _this$props3.summaryType,
          summaryHoverAnnotation = _this$props3.summaryHoverAnnotation,
          pieceHoverAnnotation = _this$props3.pieceHoverAnnotation,
          hoverAnnotation = _this$props3.hoverAnnotation,
          canvasPostProcess = _this$props3.canvasPostProcess,
          baseMarkProps = _this$props3.baseMarkProps,
          useSpans = _this$props3.useSpans,
          canvasPieces = _this$props3.canvasPieces,
          canvasSummaries = _this$props3.canvasSummaries,
          canvasConnectors = _this$props3.canvasConnectors,
          renderOrder = _this$props3.renderOrder,
          additionalDefs = _this$props3.additionalDefs,
          sketchyRenderingEngine = _this$props3.sketchyRenderingEngine,
          frameRenderOrder = _this$props3.frameRenderOrder,
          disableCanvasInteraction = _this$props3.disableCanvasInteraction;
      var _this$state3 = this.state,
          orFrameRender = _this$state3.orFrameRender,
          projectedColumns = _this$state3.projectedColumns,
          adjustedPosition = _this$state3.adjustedPosition,
          adjustedSize = _this$state3.adjustedSize,
          legendSettings = _this$state3.legendSettings,
          columnOverlays = _this$state3.columnOverlays,
          axesTickLines = _this$state3.axesTickLines,
          axes = _this$state3.axes,
          margin = _this$state3.margin,
          pieceDataXY = _this$state3.pieceDataXY,
          oLabels = _this$state3.oLabels,
          title = _this$state3.title;
      var size = [adjustedSize[0] + margin.left + margin.right, adjustedSize[1] + margin.top + margin.bottom];
      var interactionOverflow;

      if (summaryType && summaryType.amplitude) {
        if (projection === "horizontal") {
          interactionOverflow = {
            top: summaryType.amplitude,
            bottom: 0,
            left: 0,
            right: 0
          };
        } else if (projection === "radial") {
          interactionOverflow = defaultOverflow;
        } else {
          interactionOverflow = {
            top: 0,
            bottom: 0,
            left: summaryType.amplitude,
            right: 0
          };
        }
      }

      var renderedForegroundGraphics = typeof foregroundGraphics === "function" ? foregroundGraphics({
        size: size,
        margin: margin
      }) : foregroundGraphics;
      return React.createElement(_Frame.default, {
        name: "ordinalframe",
        renderPipeline: orFrameRender,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        size: size,
        xScale: xScale,
        yScale: yScale,
        axes: axes,
        useSpans: useSpans,
        axesTickLines: axesTickLines,
        title: title,
        matte: matte,
        additionalDefs: additionalDefs,
        className: "".concat(className, " ").concat(projection),
        frameKey: "none",
        renderFn: renderKey,
        projectedCoordinateNames: projectedCoordinatesObject,
        defaultSVGRule: this.defaultORSVGRule.bind(this),
        defaultHTMLRule: this.defaultORHTMLRule.bind(this),
        hoverAnnotation: summaryHoverAnnotation || pieceHoverAnnotation || hoverAnnotation,
        annotations: annotations,
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        interaction: interaction && _objectSpread({}, interaction, {
          brush: interaction.columnsBrush !== true && "oBrush",
          projection: projection,
          projectedColumns: projectedColumns
        }),
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: pieceDataXY,
        margin: margin,
        columns: projectedColumns,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: renderedForegroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        overlay: columnOverlays,
        rScale: this.state.rScale,
        projection: projection,
        disableContext: disableContext,
        interactionOverflow: interactionOverflow,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        canvasRendering: !!(canvasPieces || canvasSummaries || canvasConnectors),
        renderOrder: renderOrder,
        disableCanvasInteraction: disableCanvasInteraction,
        sketchyRenderingEngine: sketchyRenderingEngine,
        frameRenderOrder: frameRenderOrder,
        additionalVizElements: oLabels
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var props = prevState.props;

      if (prevState.dataVersion && prevState.dataVersion !== nextProps.dataVersion || !prevState.projectedColumns || props.size[0] !== nextProps.size[0] || props.size[1] !== nextProps.size[1] || !prevState.dataVersion && _frame_props.orFrameChangeProps.find(function (d) {
        return props[d] !== nextProps[d];
      })) {
        return _objectSpread({}, (0, _ordinal.calculateOrdinalFrame)(nextProps, prevState), {
          props: nextProps
        });
      } else {
        return {
          props: nextProps
        };
      }
    }
  }]);

  return OrdinalFrame;
}(React.Component);

_defineProperty(OrdinalFrame, "defaultProps", {
  annotations: [],
  foregroundGraphics: [],
  annotationSettings: {},
  projection: "vertical",
  size: [500, 500],
  className: "",
  data: [],
  oScaleType: _d3Scale.scaleBand,
  rScaleType: _d3Scale.scaleLinear,
  type: "none",
  summaryType: "none",
  useSpans: false,
  optimizeCustomTooltipPosition: false
});

_defineProperty(OrdinalFrame, "displayName", "OrdinalFrame");

var _default = OrdinalFrame;
exports.default = _default;
module.exports = exports.default;